export default {"src":"/_next/static/media/arrow-circle.5cdca889.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};